import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _RefreshIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        d="M10.229 4.19938C12.9081 3.59319 15.7109 4.4039 17.6527 6.34671C17.6601 6.3541 17.6676 6.36137 17.6752 6.36853L20.5257 8.99976H17C16.4477 8.99976 16 9.44747 16 9.99976C16 10.552 16.4477 10.9998 17 10.9998H23C23.5523 10.9998 24 10.552 24 9.99976V3.99976C24 3.44747 23.5523 2.99976 23 2.99976C22.4477 2.99976 22 3.44747 22 3.99976V7.63894L19.0559 4.92147C16.6291 2.50118 13.1313 1.49214 9.78761 2.24869C6.4387 3.00642 3.71272 5.4293 2.5673 8.66618C2.38306 9.18683 2.65577 9.75825 3.17642 9.94249C3.69706 10.1267 4.26849 9.85402 4.45273 9.33337C5.36907 6.74387 7.54986 4.80557 10.229 4.19938Z"
        fill={iconColor}
      />
      <Path
        d="M2 16.3606V19.9998C2 20.552 1.55228 20.9998 1 20.9998C0.447715 20.9998 0 20.552 0 19.9998V13.9998C0 13.4475 0.447715 12.9998 1 12.9998H7C7.55228 12.9998 8 13.4475 8 13.9998C8 14.552 7.55228 14.9998 7 14.9998H3.47424L6.32478 17.631C6.3324 17.6382 6.3399 17.6455 6.34729 17.6528C8.28912 19.5957 11.0919 20.4064 13.771 19.8002C16.4502 19.194 18.6309 17.2557 19.5473 14.6662C19.7315 14.1455 20.303 13.8728 20.8236 14.0571C21.3442 14.2413 21.617 14.8127 21.4327 15.3334C20.2873 18.5702 17.5613 20.9931 14.2124 21.7509C10.8687 22.5074 7.37096 21.4984 4.94411 19.0781L2 16.3606Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const RefreshIcon = assignWithoutSideEffects(_RefreshIcon, {
  componentId: 'RefreshIcon',
});

export default RefreshIcon;
